module.exports = __webpack_public_path__ + "assets/img/heart.256aebd7.svg";